import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/auth-context';
import OraChatBot from '../OraChatBot/OraChatBot';
import './HomeLandingPage.scss';

const pageTitle = 'Osteoarthritis';
const pageSubTitle = 'What is knee osteoarthritis and how to use this tool?';
const pageDescription = 'Hi, I’m Dr. Fang an Orthopedic surgeon. Osteoarthritis is a common degenerative condition of the knee where the cartilage covering the joint gradually wears away. As the protective cartilage wears away, your knee can become painful, swollen and stiff. This tool is designed to teach you more about osteoarthritis and allows you to put in how you are feeling about your knee. This information will help you and your medical provider make a better decision about your treatment. This tool should only take you about 5-10 minutes to complete. Please start at Step one and review the treatment options. In step two, we will ask you to put in your feelings about your knee and how you want to be treated. Step three includes a simple quiz to make sure you understand your options. This information will be given to your medical provider who will help you get started on the best treatment for your situation. This tool also includes an informational chatbot that you can ask questions at any time. Just click on the icon in the lower right corner to give it a try!';
const videoKey = '_8-E1U6L4jQ';

const HomeLandingPage = () => {
    const navigate = useNavigate();
    const { isAuthLoading, isAuthenticated } = useAuth();
    const isRedirectedAfterLogin = useRef(false);

    useEffect(() => {
        if (isAuthLoading || !isAuthenticated) {
            return;
        }

        if (isRedirectedAfterLogin.current) {
            return;
        }

        const savedURL = localStorage.getItem('preLoginURL') || '';
        localStorage.removeItem('preLoginURL');
        if (savedURL) {
            navigate(savedURL);
            isRedirectedAfterLogin.current = true;
            return;
        }

        isRedirectedAfterLogin.current = true;
    }, [ isAuthLoading, isAuthenticated, navigate ]);

    return (
        <div className="physical-therapy">
            <OraChatBot pageTitle={pageTitle}/>

            <h1 className="page-title">{pageTitle}</h1>

            <section className="video-intro-section" id="video-introduction">
                <div className="container">
                    <div className="video-intro-content">
                        <div className="video-intro-player">
                            <iframe
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                id="main-video"
                                src={`https://www.youtube.com/embed/${videoKey}`}
                                title={pageTitle}
                            />
                        </div>
                        <div className="video-intro-text">
                            <div className="overview-text">
                                <p className="lead">{pageSubTitle}</p>
                                <p>{pageDescription}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </div>
    );

};

export default HomeLandingPage;